import React, { useRef } from "react";
import { compose } from "recompose";
import { withTable, getStatus } from "components/common";
import { withXeroErrors, withDocumentRenderer } from "components";
import { Table as ReactstrapTable } from "reactstrap";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import { CurrencySymbol, formatCurrency } from "services/util";
import Search from "./Search";
import { PurchaseOrderDocument } from "components/documents";
import { useOrganisationContext } from "hooks";
import { TruncateTd } from "components/common/Tables";

const EmailCell = withDocumentRenderer({
  onDownload: () => (getDocument, item) =>
    getDocument(
      {
        item,
      },
      `cust_${item.PurchaseOrderNumber}.pdf`
    ),
  type: "PURCHASE_ORDER",
})(({ EmailDocument, DocumentRenderer, i, selectedOrganisation }) => (
  <>
    <EmailDocument compact item={i} type="PURCHASE_ORDER" />
    <DocumentRenderer component={PurchaseOrderDocument} selectedOrganisation={selectedOrganisation}/>
  </>
));

const DownloadCell = withDocumentRenderer({
  onDownload: () => (getDocument, item) =>
    getDocument(
      {
        item,
      },
      `cust_${item.PurchaseOrderNumber}.pdf`
    ),
  type: "PURCHASE_ORDER",
})(({ DownloadDocument, DocumentRenderer, i, selectedOrganisation }) => (
  <>
    <DownloadDocument compact item={i} className="mr-1" />
    <DocumentRenderer component={PurchaseOrderDocument} selectedOrganisation={selectedOrganisation}/>
  </>
));


export const Table = ({
  XeroErrors,
  Pagination,
  TableContainer,
  ViewingRecords,
  Loader,
  XeroTableDataFetch,
  data,
  setFilters,
  status,
  filters,
  selected,
}) => {
  const initialFilters = useRef(filters);
  const {selectedOrganisation} = useOrganisationContext()
  return (
    <div>
      <XeroErrors color="warning" />
      <Search
        onFiltersChanged={(v) => {
          setFilters(v === null ? initialFilters.current : v);
        }}
        status={status}
        data={data}
        selected={selected}
        selectedOrganisation={selectedOrganisation}
      />
      <div className="small inv-table">
        <TableContainer idKey="PurchaseOrderID">
          <ReactstrapTable size="sm" className="small">
            <thead>
              <tr>
                <th select />
                <th sortBy="PurchaseOrderNumber">
                  <Trans>Number</Trans>
                </th>
                <th sortBy="Reference">
                  <Trans>Reference</Trans>
                </th>
                <th sortBy="Contact.Name">
                  <Trans>Supplier</Trans>
                </th>
                <th sortBy="Date">
                  <Trans>Date raised</Trans>
                </th>
                <th sortBy="DeliveryDate">
                  <Trans>Delivery date</Trans>
                </th>
                <th sortBy="Total">
                  <Trans>Amount</Trans>
                </th>
                <th sortBy="Status">
                  <Trans>Status</Trans>
                </th>
                <th className="text-nowrap">
                  <Trans>Actions</Trans>
                </th>
                {/* <th sortBy="SentToContact">
                  <Trans>Sent</Trans>
                </th> */}
              </tr>
            </thead>
            <tbody>
              <Loader />
              {data.results.map((i, idx) => (
                <tr key={i.PurchaseOrderID}>
                  <td select />
                  
                  <TruncateTd content={i.PurchaseOrderNumber} _key={`number_${idx}`} className="truncate">
                    <Link to={`/purchases/purchase_orders/view/${i.PurchaseOrderID}`} >
                        {i.PurchaseOrderNumber}
                    </Link>
                  </TruncateTd>

                  <TruncateTd content={i.Reference || ("-")} _key={`reference_${idx}`} className="truncate">
                    {i.Reference || ("-")}
                  </TruncateTd>

                  <TruncateTd content={i.Contact?.Name || ("-")} _key={`contact_${idx}`} className="truncate">
                    <Link to={`/contacts/view/${i.Contact.ContactID}`}>
                      {i.Contact.Name}
                    </Link>
                  </TruncateTd>

                  <td>{i.DateString}</td>
                  <td>{i.DeliveryDateString}</td>
                  <td>
                    {formatCurrency(i.Total)} <CurrencySymbol currency={i.CurrencyCode} />
                  </td>
                  <td>
                    <Trans>{getStatus(i.Status)}</Trans>
                  </td>
                  <td className="text-nowrap">
                    <DownloadCell i={i} selectedOrganisation={selectedOrganisation}/>
                    <EmailCell i={i} selectedOrganisation={selectedOrganisation}/>
                  </td>
                  {/* <td className="text-success">
                    {i.SentToContact ? <Trans>Sent</Trans> : ""}
                  </td> */}
                </tr>
              ))}
            </tbody>
          </ReactstrapTable>
        </TableContainer>
      </div>
      <XeroTableDataFetch />
      <div className="float-right">
        <Pagination size="sm" noPages />
      </div>
      <div className="clearfix">
        <ViewingRecords noCount className="float-left" />
      </div>
    </div>
  );
};

export const enhance = compose(
  withXeroErrors(),
  withTable({
    limit: 50,
    url: "purchaseorders",
    ordering: {
      column: "Date",
      direction: 2,
    },
  })
);

export default enhance(Table);
